//CUSTOM JS GOES HERE

var supportPageOffset = window.pageXOffset !== undefined;
var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

var scrollLeft = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
var scrollTop = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;


const navBtnIcon = document.getElementById('hamburger-icon');
const navBtn = document.getElementById('nav-button');
const navWrapper = document.getElementById('main-nav-wrap');
const navPanel = document.getElementById('main-nav');
const navEmpty = document.getElementById('main-nav-empty');
const navClose = document.getElementById('nav-close');
const searchBtn = document.getElementById('search-btn');
const searchForm = document.getElementById('search-form');

function close_nav(){
    navWrapper.classList.remove('nav-open');
    // navBtn.style.display = 'block';
}

navBtnIcon.addEventListener('click', (e)=>{
    // navBtn.style.display = 'none';
    navWrapper.classList.add('nav-open');
});

function closeNav(){
    navWrapper.classList.remove('nav-open');
    navBtn.style.display = 'block';
}

navClose.addEventListener('click', ()=>{
    closeNav();    
});

navEmpty.addEventListener('click', ()=>{
    closeNav();    
});

searchBtn.addEventListener('click', (e)=>{      
    searchForm.submit(); // Submit the form
 });


 document.addEventListener('facetwp-loaded', function() {
    var urlParams = new URLSearchParams(window.location.search);
    if(urlParams != "") {
        var myParam = urlParams.get('_track').replace(/[^a-z0-9-]/gi, '');
        document.getElementById('dropdown-filter').value = myParam;
    } else {
        document.getElementById('dropdown-filter').value = "-1";
    }
});

 jQuery(document).ready(function() {
    jQuery("#dropdown-filter").change(function(){
        var curr_val = $(this).val();
        if($(this).val() == "-1") {
            $(".facetwp-radio[data-value='']").click();
        } else {
            $(".facetwp-radio[data-value='" + curr_val + "']").click();
        }
    });
 });




/* KEEP NAVIGATION ONSCREEN */

window.onscroll = ()=>{
    if (navWrapper.classList.contains('nav-open') && (window.matchMedia('screen and (min-width: 992px)').matches)) {
		let elementTopString = navPanel.style.top;
            elementTopString.replace('px', '');
            let elementTop = parseInt(elementTopString);
		if (scrollTop > elementTop + 450 || scrollTop < elementTop - 450 ) {
			navWrapper.classList.remove('nav-open');
		}
	}
}


if(document.querySelector('.track-select-wrapper')){
    document.querySelector('.track-select-wrapper').addEventListener('click', function() {
        this.querySelector('.track-select-wrapper .select').classList.toggle('open');
    })
}


window.addEventListener('click', function(e) {
    const select = document.querySelector('.track-select-wrapper .select')
    if (!select.contains(e.target)) {
        select.classList.remove('open');
    }
});

window.addEventListener('load', function(e) {
    const trackSelect = document.querySelector('.track-select-wrapper')
    if(trackSelect){
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
        let track = params._track;
        if(track){
            track = track.replace('-', ' ').toUpperCase();
            trackSelect.querySelector('.select__trigger span').textContent = track;
        }else{
            trackSelect.querySelector('.select__trigger span').textContent = 'VIEW ALL';
        }
    }
});